import docsLink from "../../public/assets/docsLink";
// Assets
export const navigationItems = [
  {
    displayName: "Getting Started",
    link: "/getting-started",
    icon: "nav-getting-started",
    sections: [],
    subsections: [],
    position: "top"
  },
  {
    displayName: "Overview",
    link: "/overview",
    icon: "nav-overview",
    sections: [],
    subsections: [],
    position: "top"
  },
  {
    displayName: "Applications",
    link: "/applications",
    icon: "nav-applications",
    subsections: [],
    sections: [],
    position: "top"
  },
  {
    displayName: "Authentication",
    link: "/authentication",
    icon: "nav-authentication",
    subsections: [
      [
        {
          displayName: "Auth Configuration",
          link: "/authentication-configuration"
        },
        {
          displayName: "Identity Providers",
          link: "/identity-providers"
        }
      ]
    ],
    sections: [],
    position: "top"
  },
  {
    displayName: "Authorization",
    link: "/authorization",
    icon: "nav-authorization",
    subsections: [
      [
        {
          displayName: "Roles & Permissions",
          link: "/roles"
        },
        {
          displayName: "APIs",
          link: "/apis"
        }
      ]
    ],
    sections: [],
    position: "top"
  },
  {
    displayName: "Security",
    link: "/security",
    icon: "nav-security",
    subsections: [
      [
        {
          displayName: "Attack Protection",
          link: "/attack-protection",
          sections: [
            {
              displayName: "Brute Force Protection",
              link: "/brute-force-protection"
            },
            {
              displayName: "Bot Protection",
              link: "/bot-protection"
            },
            {
              displayName: "Breached Password Protection",
              link: "/breached-password-protection"
            },
            {
              displayName: "Domain Access Management",
              link: "/domain-access-management"
            }
          ]
        },
        {
          displayName: "Session Management",
          link: "/session-management"
        },
        {
          displayName: "Multi Factor Authentication",
          link: "/multi-factor-authentication"
        },
        {
          displayName: "Risk-Based Authentication",
          link: "/risk-based-authentication",
          sections: [
            {
              displayName: "Additional Settings",
              link: "/settings"
            }
          ]
        },
        {
          displayName: "Security Questions",
          link: "/security-questions"
        },
        {
          displayName: "PIN Authentication",
          link: "/pin-authentication"
        },
        {
          displayName: "Privacy and Consent",
          link: "/privacy-and-consent",
          sections: [
            {
              displayName: "Privacy Versioning",
              link: "/privacy-versioning"
            },
            {
              displayName: "Consent Management",
              link: "/consent-management"
            }
          ]
        }
      ]
    ],
    sections: [],
    position: "top"
  },
  {
    displayName: "Branding",
    link: "/branding",
    icon: "nav-branding",
    sections: [],
    subsections: [
      [
        {
          displayName: "Auth Studio",
          link: "/auth-studio",
          sections: [
            {
              displayName: "New Brand",
              link: "/new"
            }
          ]
        },
        {
          displayName: "Custom Domain",
          link: "/custom-domain"
        },
        {
          displayName: "Email / SMS Provider",
          link: "/email-sms-provider"
        },
        {
          displayName: "Email Templates",
          link: "/email-templates"
        },
        {
          displayName: "SMS Templates",
          link: "/sms-templates"
        },
        {
          displayName: "Forms",
          link: "/forms"
        },
        {
          displayName: "JS Widgets",
          link: "/js-widgets",
          sections: [
            { displayName: "Settings", link: "/settings", icon: "advance_setting" },
            { displayName: "Registration Forms", link: "/registration-forms", icon: "registration_forms" },
            { displayName: "Login", link: "/login", icon: "input" },
            { displayName: "Registration", link: "/registration", icon: "content_paste" },
            { displayName: "Forgot Password", link: "/forgotpassword", icon: "help_outline" },
            { displayName: "Other Widgets", link: "/otherwidgets", dropdown: true, icon: "widgets" },
            { parentTabId: "otherwidgets", displayName: "Reset Password", link: "/resetpassword", icon: "settings_backup_restore" },
            { parentTabId: "otherwidgets", displayName: "Verify Email", link: "/verifyemail", icon: "check" },
            { parentTabId: "otherwidgets", displayName: "Change Password", link: "/changepassword", icon: "change_history" },
            { parentTabId: "otherwidgets", displayName: "Social Login", link: "/sociallogin", icon: "recent_actors" },
            { parentTabId: "otherwidgets", displayName: "Link Account", link: "/linkaccount", icon: "link" },
            { parentTabId: "otherwidgets", displayName: "Unlink Account", link: "/unlinkaccount", icon: "unlink" },
            { parentTabId: "otherwidgets", displayName: "Profile Editor", link: "/profileeditor", icon: "person_add" },
            { parentTabId: "otherwidgets", displayName: "Two Factor Authentication", link: "/twofactorauthentication", icon: "call_split" },
            { parentTabId: "otherwidgets", displayName: "Add Email", link: "/addemail", icon: "mail_outline" },
            { parentTabId: "otherwidgets", displayName: "Remove Email", link: "/removeemail", icon: "remove_circle_outline" },
            { parentTabId: "otherwidgets", displayName: "Resend Email Verification", link: "/resendemailverification", icon: "contact_mail" },
            { parentTabId: "otherwidgets", displayName: "Change Username", link: "/changeusername", icon: "account_box" },
            { parentTabId: "otherwidgets", displayName: "Update Phone Number", link: "/updatephonenumber", icon: "contact_phone" },
            { parentTabId: "otherwidgets", displayName: "Auto Login", link: "/passwordlessloginvalidate", icon: "textsms" }
          ]
        }
      ]
    ],
    position: "top"
  },
  {
    displayName: "Orchestration",
    link: "/orchestration",
    icon: "nav-orchestration",
    sections: [],
    subsections: [
      [
        {
          displayName: "Workflows",
          link: "/workflows",
          sections: [
            {
              displayName: "New Workflow",
              link: "/new"
            },
            {
              displayName: "Workflow Editor",
              link: "/edit"
            },
            {
              displayName: "Workflow Templates",
              link: "/templates"
            }
          ]
        },
        {
          displayName: "Scripts",
          link: "/scripts"
        },
        {
          displayName: "Logs",
          link: "/logs"
        }
      ]
    ],
    position: "top"
  },
  {
    displayName: "Organizations",
    link: "/organizations",
    icon: "nav-organizations",
    subsections: [],
    sections: [
      {
        displayName: "Organization Details",
        link: "/details"
      }
    ],
    position: "top"
  },
  {
    displayName: "Users",
    link: "/users",
    icon: "nav-users",
    subsections: [
      [
        {
          displayName: "Manage Users",
          link: "/manage-user",
          sections: [
            {
              displayName: "User Details",
              link: "/user-details"
            }
          ]
        },
        {
          displayName: "User Audit Logs",
          link: "/user-audit-logs"
        },
        {
          displayName: "Data Export",
          link: "/data-export"
        }
      ]
    ],
    sections: [],
    position: "top"
  },
  {
    displayName: "Integration",
    link: "/integrations",
    icon: "nav-integration",
    sections: [],
    subsections: [
      [
        {
          displayName: "Webhook",
          link: "/webhook"
        },
        {
          displayName: "SSO Integrations",
          link: "/sso-integrations"
        },
        {
          displayName: "Third Party Software",
          link: "/third-party-software"
        },
        {
          displayName: "Audit Log Integration",
          link: "/audit-log-integration"
        }
      ]
    ],
    position: "top"
  },
  {
    displayName: "Insights",
    link: "/insights",
    icon: "nav-insights",
    sections: [],
    subsections: [
      [
        {
          displayName: "User Analytics",
          link: "/user-analytics"
        },
        {
          displayName: "User Segmentations",
          link: "/user-segmentations",
          sections: [
            {
              displayName: "User Details",
              link: "/user-details"
            },
            {
              displayName: "Create Segmentation",
              link: "/new"
            }
          ]
        },
        {
          displayName: "Platform Analytics",
          link: "/platform-analytics"
        },
        {
          displayName: "Security Analytics",
          link: "/security-analytics"
        }
      ]
    ],
    position: "top"
  },
  {
    displayName: "Get Support",
    link: "/get-support",
    icon: "nav-support",
    sections: [],
    subsections: [],
    position: "bottom"
  },
  {
    displayName: "Billing",
    link: "/billing",
    icon: "nav-billing",
    sections: [],
    subsections: [],
    position: "bottom"
  }
];

export const dataCenters = {
  "MongoDbUS-East": "USEast",
  "MongoDbUS-East-1": "USEast1",
  "MongoDbUS-West": "USWest",
  "MongoDbUS-Central": "USCentral",
  "MongoDbUK-South": "UKSouth",
  "MongoDbUK-Bbc": "UKBbc",
  "MongoDbEU-East": "EUEast",
  "MongoDbEU-West": "EUWest",
  MongoDbAsia: "Asia",
  "MongoDbAsia-East": "AsiaEast",
  MongoDbAUS: "AUS",
  "MongoDbCA-East": "CAEast",
  "MongoDbCA-Central": "CACentral"
};
export const timeZonesJson = [
  {
    value: "Dateline Standard Time",
    abbr: "DST",
    offset: -12,
    isdst: false,
    text: "(UTC-12:00) International Date Line West",
    utc: ["Etc/GMT+12"]
  },
  {
    value: "UTC-11",
    abbr: "U",
    offset: -11,
    isdst: false,
    text: "(UTC-11:00) Coordinated Universal Time-11",
    utc: ["Etc/GMT+11", "Pacific/Midway", "Pacific/Niue", "Pacific/Pago_Pago"]
  },
  {
    value: "Hawaiian Standard Time",
    abbr: "HST",
    offset: -10,
    isdst: false,
    text: "(UTC-10:00) Hawaii",
    utc: ["Etc/GMT+10", "Pacific/Honolulu", "Pacific/Johnston", "Pacific/Rarotonga", "Pacific/Tahiti"]
  },
  {
    value: "Alaskan Standard Time",
    abbr: "AKDT",
    offset: -8,
    isdst: true,
    text: "(UTC-09:00) Alaska",
    utc: ["America/Anchorage", "America/Juneau", "America/Nome", "America/Sitka", "America/Yakutat"]
  },
  {
    value: "Pacific Standard Time (Mexico)",
    abbr: "PDT",
    offset: -7,
    isdst: true,
    text: "(UTC-08:00) Baja California",
    utc: ["America/Santa_Isabel"]
  },
  {
    value: "Pacific Standard Time",
    abbr: "PDT",
    offset: -7,
    isdst: true,
    text: "(UTC-08:00) Pacific Time (US & Canada)",
    utc: ["America/Dawson", "America/Los_Angeles", "America/Tijuana", "America/Vancouver", "America/Whitehorse", "PST8PDT"]
  },
  {
    value: "US Mountain Standard Time",
    abbr: "UMST",
    offset: -7,
    isdst: false,
    text: "(UTC-07:00) Arizona",
    utc: ["America/Creston", "America/Dawson_Creek", "America/Hermosillo", "America/Phoenix", "Etc/GMT+7"]
  },
  {
    value: "Mountain Standard Time (Mexico)",
    abbr: "MDT",
    offset: -6,
    isdst: true,
    text: "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
    utc: ["America/Chihuahua", "America/Mazatlan"]
  },
  {
    value: "Mountain Standard Time",
    abbr: "MDT",
    offset: -6,
    isdst: true,
    text: "(UTC-07:00) Mountain Time (US & Canada)",
    utc: ["America/Boise", "America/Cambridge_Bay", "America/Denver", "America/Edmonton", "America/Inuvik", "America/Ojinaga", "America/Yellowknife", "MST7MDT"]
  },
  {
    value: "Central America Standard Time",
    abbr: "CAST",
    offset: -6,
    isdst: false,
    text: "(UTC-06:00) Central America",
    utc: ["America/Belize", "America/Costa_Rica", "America/El_Salvador", "America/Guatemala", "America/Managua", "America/Tegucigalpa", "Etc/GMT+6", "Pacific/Galapagos"]
  },
  {
    value: "Central Standard Time",
    abbr: "CDT",
    offset: -5,
    isdst: true,
    text: "(UTC-06:00) Central Time (US & Canada)",
    utc: [
      "America/Chicago",
      "America/Indiana/Knox",
      "America/Indiana/Tell_City",
      "America/Matamoros",
      "America/Menominee",
      "America/North_Dakota/Beulah",
      "America/North_Dakota/Center",
      "America/North_Dakota/New_Salem",
      "America/Rainy_River",
      "America/Rankin_Inlet",
      "America/Resolute",
      "America/Winnipeg",
      "CST6CDT"
    ]
  },
  {
    value: "Central Standard Time (Mexico)",
    abbr: "CDT",
    offset: -5,
    isdst: true,
    text: "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
    utc: ["America/Bahia_Banderas", "America/Cancun", "America/Merida", "America/Mexico_City", "America/Monterrey"]
  },
  {
    value: "Canada Central Standard Time",
    abbr: "CCST",
    offset: -6,
    isdst: false,
    text: "(UTC-06:00) Saskatchewan",
    utc: ["America/Regina", "America/Swift_Current"]
  },
  {
    value: "SA Pacific Standard Time",
    abbr: "SPST",
    offset: -5,
    isdst: false,
    text: "(UTC-05:00) Bogota, Lima, Quito",
    utc: ["America/Bogota", "America/Cayman", "America/Coral_Harbour", "America/Eirunepe", "America/Guayaquil", "America/Jamaica", "America/Lima", "America/Panama", "America/Rio_Branco", "Etc/GMT+5"]
  },
  {
    value: "Eastern Standard Time",
    abbr: "EDT",
    offset: -4,
    isdst: true,
    text: "(UTC-05:00) Eastern Time (US & Canada)",
    utc: [
      "America/Detroit",
      "America/Havana",
      "America/Indiana/Petersburg",
      "America/Indiana/Vincennes",
      "America/Indiana/Winamac",
      "America/Iqaluit",
      "America/Kentucky/Monticello",
      "America/Louisville",
      "America/Montreal",
      "America/Nassau",
      "America/New_York",
      "America/Nipigon",
      "America/Pangnirtung",
      "America/Port-au-Prince",
      "America/Thunder_Bay",
      "America/Toronto",
      "EST5EDT"
    ]
  },
  {
    value: "US Eastern Standard Time",
    abbr: "UEDT",
    offset: -4,
    isdst: true,
    text: "(UTC-05:00) Indiana (East)",
    utc: ["America/Indiana/Marengo", "America/Indiana/Vevay", "America/Indianapolis"]
  },
  {
    value: "Venezuela Standard Time",
    abbr: "VST",
    offset: -4.5,
    isdst: false,
    text: "(UTC-04:30) Caracas",
    utc: ["America/Caracas"]
  },
  {
    value: "Paraguay Standard Time",
    abbr: "PST",
    offset: -4,
    isdst: false,
    text: "(UTC-04:00) Asuncion",
    utc: ["America/Asuncion"]
  },
  {
    value: "Atlantic Standard Time",
    abbr: "ADT",
    offset: -3,
    isdst: true,
    text: "(UTC-04:00) Atlantic Time (Canada)",
    utc: ["America/Glace_Bay", "America/Goose_Bay", "America/Halifax", "America/Moncton", "America/Thule", "Atlantic/Bermuda"]
  },
  {
    value: "Central Brazilian Standard Time",
    abbr: "CBST",
    offset: -4,
    isdst: false,
    text: "(UTC-04:00) Cuiaba",
    utc: ["America/Campo_Grande", "America/Cuiaba"]
  },
  {
    value: "SA Western Standard Time",
    abbr: "SWST",
    offset: -4,
    isdst: false,
    text: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
    utc: [
      "America/Anguilla",
      "America/Antigua",
      "America/Aruba",
      "America/Barbados",
      "America/Blanc-Sablon",
      "America/Boa_Vista",
      "America/Curacao",
      "America/Dominica",
      "America/Grand_Turk",
      "America/Grenada",
      "America/Guadeloupe",
      "America/Guyana",
      "America/Kralendijk",
      "America/La_Paz",
      "America/Lower_Princes",
      "America/Manaus",
      "America/Marigot",
      "America/Martinique",
      "America/Montserrat",
      "America/Port_of_Spain",
      "America/Porto_Velho",
      "America/Puerto_Rico",
      "America/Santo_Domingo",
      "America/St_Barthelemy",
      "America/St_Kitts",
      "America/St_Lucia",
      "America/St_Thomas",
      "America/St_Vincent",
      "America/Tortola",
      "Etc/GMT+4"
    ]
  },
  {
    value: "Pacific SA Standard Time",
    abbr: "PSST",
    offset: -4,
    isdst: false,
    text: "(UTC-04:00) Santiago",
    utc: ["America/Santiago", "Antarctica/Palmer"]
  },
  {
    value: "Newfoundland Standard Time",
    abbr: "NDT",
    offset: -2.5,
    isdst: true,
    text: "(UTC-03:30) Newfoundland",
    utc: ["America/St_Johns"]
  },
  {
    value: "E. South America Standard Time",
    abbr: "ESAST",
    offset: -3,
    isdst: false,
    text: "(UTC-03:00) Brasilia",
    utc: ["America/Sao_Paulo"]
  },
  {
    value: "Argentina Standard Time",
    abbr: "AST",
    offset: -3,
    isdst: false,
    text: "(UTC-03:00) Buenos Aires",
    utc: [
      "America/Argentina/La_Rioja",
      "America/Argentina/Rio_Gallegos",
      "America/Argentina/Salta",
      "America/Argentina/San_Juan",
      "America/Argentina/San_Luis",
      "America/Argentina/Tucuman",
      "America/Argentina/Ushuaia",
      "America/Buenos_Aires",
      "America/Catamarca",
      "America/Cordoba",
      "America/Jujuy",
      "America/Mendoza"
    ]
  },
  {
    value: "SA Eastern Standard Time",
    abbr: "SEST",
    offset: -3,
    isdst: false,
    text: "(UTC-03:00) Cayenne, Fortaleza",
    utc: [
      "America/Araguaina",
      "America/Belem",
      "America/Cayenne",
      "America/Fortaleza",
      "America/Maceio",
      "America/Paramaribo",
      "America/Recife",
      "America/Santarem",
      "Antarctica/Rothera",
      "Atlantic/Stanley",
      "Etc/GMT+3"
    ]
  },
  {
    value: "Greenland Standard Time",
    abbr: "GDT",
    offset: -2,
    isdst: true,
    text: "(UTC-03:00) Greenland",
    utc: ["America/Godthab"]
  },
  {
    value: "Montevideo Standard Time",
    abbr: "MST",
    offset: -3,
    isdst: false,
    text: "(UTC-03:00) Montevideo",
    utc: ["America/Montevideo"]
  },
  {
    value: "Bahia Standard Time",
    abbr: "BST",
    offset: -3,
    isdst: false,
    text: "(UTC-03:00) Salvador",
    utc: ["America/Bahia"]
  },
  {
    value: "UTC-02",
    abbr: "U",
    offset: -2,
    isdst: false,
    text: "(UTC-02:00) Coordinated Universal Time-02",
    utc: ["America/Noronha", "Atlantic/South_Georgia", "Etc/GMT+2"]
  },
  {
    value: "Mid-Atlantic Standard Time",
    abbr: "MDT",
    offset: -1,
    isdst: true,
    text: "(UTC-02:00) Mid-Atlantic - Old"
  },
  {
    value: "Azores Standard Time",
    abbr: "ADT",
    offset: 0,
    isdst: true,
    text: "(UTC-01:00) Azores",
    utc: ["America/Scoresbysund", "Atlantic/Azores"]
  },
  {
    value: "Cape Verde Standard Time",
    abbr: "CVST",
    offset: -1,
    isdst: false,
    text: "(UTC-01:00) Cape Verde Is.",
    utc: ["Atlantic/Cape_Verde", "Etc/GMT+1"]
  },
  {
    value: "Morocco Standard Time",
    abbr: "MDT",
    offset: 1,
    isdst: true,
    text: "(UTC) Casablanca",
    utc: ["Africa/Casablanca", "Africa/El_Aaiun"]
  },
  {
    value: "UTC",
    abbr: "CUT",
    offset: 0,
    isdst: false,
    text: "(UTC) Coordinated Universal Time",
    utc: ["America/Danmarkshavn", "Etc/GMT"]
  },
  {
    value: "GMT Standard Time",
    abbr: "GDT",
    offset: 1,
    isdst: true,
    text: "(UTC) Dublin, Edinburgh, Lisbon, London",
    utc: ["Atlantic/Canary", "Atlantic/Faeroe", "Atlantic/Madeira", "Europe/Dublin", "Europe/Guernsey", "Europe/Isle_of_Man", "Europe/Jersey", "Europe/Lisbon", "Europe/London"]
  },
  {
    value: "Greenwich Standard Time",
    abbr: "GST",
    offset: 0,
    isdst: false,
    text: "(UTC) Monrovia, Reykjavik",
    utc: [
      "Africa/Abidjan",
      "Africa/Accra",
      "Africa/Bamako",
      "Africa/Banjul",
      "Africa/Bissau",
      "Africa/Conakry",
      "Africa/Dakar",
      "Africa/Freetown",
      "Africa/Lome",
      "Africa/Monrovia",
      "Africa/Nouakchott",
      "Africa/Ouagadougou",
      "Africa/Sao_Tome",
      "Atlantic/Reykjavik",
      "Atlantic/St_Helena"
    ]
  },
  {
    value: "W. Europe Standard Time",
    abbr: "WEDT",
    offset: 2,
    isdst: true,
    text: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
    utc: [
      "Arctic/Longyearbyen",
      "Europe/Amsterdam",
      "Europe/Andorra",
      "Europe/Berlin",
      "Europe/Busingen",
      "Europe/Gibraltar",
      "Europe/Luxembourg",
      "Europe/Malta",
      "Europe/Monaco",
      "Europe/Oslo",
      "Europe/Rome",
      "Europe/San_Marino",
      "Europe/Stockholm",
      "Europe/Vaduz",
      "Europe/Vatican",
      "Europe/Vienna",
      "Europe/Zurich"
    ]
  },
  {
    value: "Central Europe Standard Time",
    abbr: "CEDT",
    offset: 2,
    isdst: true,
    text: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
    utc: ["Europe/Belgrade", "Europe/Bratislava", "Europe/Budapest", "Europe/Ljubljana", "Europe/Podgorica", "Europe/Prague", "Europe/Tirane"]
  },
  {
    value: "Romance Standard Time",
    abbr: "RDT",
    offset: 2,
    isdst: true,
    text: "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
    utc: ["Africa/Ceuta", "Europe/Brussels", "Europe/Copenhagen", "Europe/Madrid", "Europe/Paris"]
  },
  {
    value: "Central European Standard Time",
    abbr: "CEDT",
    offset: 2,
    isdst: true,
    text: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
    utc: ["Europe/Sarajevo", "Europe/Skopje", "Europe/Warsaw", "Europe/Zagreb"]
  },
  {
    value: "W. Central Africa Standard Time",
    abbr: "WCAST",
    offset: 1,
    isdst: false,
    text: "(UTC+01:00) West Central Africa",
    utc: [
      "Africa/Algiers",
      "Africa/Bangui",
      "Africa/Brazzaville",
      "Africa/Douala",
      "Africa/Kinshasa",
      "Africa/Lagos",
      "Africa/Libreville",
      "Africa/Luanda",
      "Africa/Malabo",
      "Africa/Ndjamena",
      "Africa/Niamey",
      "Africa/Porto-Novo",
      "Africa/Tunis",
      "Etc/GMT-1"
    ]
  },
  {
    value: "Namibia Standard Time",
    abbr: "NST",
    offset: 1,
    isdst: false,
    text: "(UTC+01:00) Windhoek",
    utc: ["Africa/Windhoek"]
  },
  {
    value: "GTB Standard Time",
    abbr: "GDT",
    offset: 3,
    isdst: true,
    text: "(UTC+02:00) Athens, Bucharest",
    utc: ["Asia/Nicosia", "Europe/Athens", "Europe/Bucharest", "Europe/Chisinau"]
  },
  {
    value: "Middle East Standard Time",
    abbr: "MEDT",
    offset: 3,
    isdst: true,
    text: "(UTC+02:00) Beirut",
    utc: ["Asia/Beirut"]
  },
  {
    value: "Egypt Standard Time",
    abbr: "EST",
    offset: 2,
    isdst: false,
    text: "(UTC+02:00) Cairo",
    utc: ["Africa/Cairo"]
  },
  {
    value: "Syria Standard Time",
    abbr: "SDT",
    offset: 3,
    isdst: true,
    text: "(UTC+02:00) Damascus",
    utc: ["Asia/Damascus"]
  },
  {
    value: "E. Europe Standard Time",
    abbr: "EEDT",
    offset: 3,
    isdst: true,
    text: "(UTC+02:00) E. Europe"
  },
  {
    value: "South Africa Standard Time",
    abbr: "SAST",
    offset: 2,
    isdst: false,
    text: "(UTC+02:00) Harare, Pretoria",
    utc: [
      "Africa/Blantyre",
      "Africa/Bujumbura",
      "Africa/Gaborone",
      "Africa/Harare",
      "Africa/Johannesburg",
      "Africa/Kigali",
      "Africa/Lubumbashi",
      "Africa/Lusaka",
      "Africa/Maputo",
      "Africa/Maseru",
      "Africa/Mbabane",
      "Etc/GMT-2"
    ]
  },
  {
    value: "FLE Standard Time",
    abbr: "FDT",
    offset: 3,
    isdst: true,
    text: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
    utc: ["Europe/Helsinki", "Europe/Kiev", "Europe/Mariehamn", "Europe/Riga", "Europe/Sofia", "Europe/Tallinn", "Europe/Uzhgorod", "Europe/Vilnius", "Europe/Zaporozhye"]
  },
  {
    value: "Turkey Standard Time",
    abbr: "TDT",
    offset: 3,
    isdst: true,
    text: "(UTC+02:00) Istanbul",
    utc: ["Europe/Istanbul"]
  },
  {
    value: "Israel Standard Time",
    abbr: "JDT",
    offset: 3,
    isdst: true,
    text: "(UTC+02:00) Jerusalem",
    utc: ["Asia/Jerusalem"]
  },
  {
    value: "Libya Standard Time",
    abbr: "LST",
    offset: 2,
    isdst: false,
    text: "(UTC+02:00) Tripoli",
    utc: ["Africa/Tripoli"]
  },
  {
    value: "Jordan Standard Time",
    abbr: "JST",
    offset: 3,
    isdst: false,
    text: "(UTC+03:00) Amman",
    utc: ["Asia/Amman"]
  },
  {
    value: "Arabic Standard Time",
    abbr: "AST",
    offset: 3,
    isdst: false,
    text: "(UTC+03:00) Baghdad",
    utc: ["Asia/Baghdad"]
  },
  {
    value: "Kaliningrad Standard Time",
    abbr: "KST",
    offset: 3,
    isdst: false,
    text: "(UTC+03:00) Kaliningrad, Minsk",
    utc: ["Europe/Kaliningrad", "Europe/Minsk"]
  },
  {
    value: "Arab Standard Time",
    abbr: "AST",
    offset: 3,
    isdst: false,
    text: "(UTC+03:00) Kuwait, Riyadh",
    utc: ["Asia/Aden", "Asia/Bahrain", "Asia/Kuwait", "Asia/Qatar", "Asia/Riyadh"]
  },
  {
    value: "E. Africa Standard Time",
    abbr: "EAST",
    offset: 3,
    isdst: false,
    text: "(UTC+03:00) Nairobi",
    utc: [
      "Africa/Addis_Ababa",
      "Africa/Asmera",
      "Africa/Dar_es_Salaam",
      "Africa/Djibouti",
      "Africa/Juba",
      "Africa/Kampala",
      "Africa/Khartoum",
      "Africa/Mogadishu",
      "Africa/Nairobi",
      "Antarctica/Syowa",
      "Etc/GMT-3",
      "Indian/Antananarivo",
      "Indian/Comoro",
      "Indian/Mayotte"
    ]
  },
  {
    value: "Iran Standard Time",
    abbr: "IDT",
    offset: 4.5,
    isdst: true,
    text: "(UTC+03:30) Tehran",
    utc: ["Asia/Tehran"]
  },
  {
    value: "Arabian Standard Time",
    abbr: "AST",
    offset: 4,
    isdst: false,
    text: "(UTC+04:00) Abu Dhabi, Muscat",
    utc: ["Asia/Dubai", "Asia/Muscat", "Etc/GMT-4"]
  },
  {
    value: "Azerbaijan Standard Time",
    abbr: "ADT",
    offset: 5,
    isdst: true,
    text: "(UTC+04:00) Baku",
    utc: ["Asia/Baku"]
  },
  {
    value: "Russian Standard Time",
    abbr: "RST",
    offset: 4,
    isdst: false,
    text: "(UTC+04:00) Moscow, St. Petersburg, Volgograd",
    utc: ["Europe/Moscow", "Europe/Samara", "Europe/Simferopol", "Europe/Volgograd"]
  },
  {
    value: "Mauritius Standard Time",
    abbr: "MST",
    offset: 4,
    isdst: false,
    text: "(UTC+04:00) Port Louis",
    utc: ["Indian/Mahe", "Indian/Mauritius", "Indian/Reunion"]
  },
  {
    value: "Georgian Standard Time",
    abbr: "GST",
    offset: 4,
    isdst: false,
    text: "(UTC+04:00) Tbilisi",
    utc: ["Asia/Tbilisi"]
  },
  {
    value: "Caucasus Standard Time",
    abbr: "CST",
    offset: 4,
    isdst: false,
    text: "(UTC+04:00) Yerevan",
    utc: ["Asia/Yerevan"]
  },
  {
    value: "Afghanistan Standard Time",
    abbr: "AST",
    offset: 4.5,
    isdst: false,
    text: "(UTC+04:30) Kabul",
    utc: ["Asia/Kabul"]
  },
  {
    value: "West Asia Standard Time",
    abbr: "WAST",
    offset: 5,
    isdst: false,
    text: "(UTC+05:00) Ashgabat, Tashkent",
    utc: ["Antarctica/Mawson", "Asia/Aqtau", "Asia/Aqtobe", "Asia/Ashgabat", "Asia/Dushanbe", "Asia/Oral", "Asia/Samarkand", "Asia/Tashkent", "Etc/GMT-5", "Indian/Kerguelen", "Indian/Maldives"]
  },
  {
    value: "Pakistan Standard Time",
    abbr: "PST",
    offset: 5,
    isdst: false,
    text: "(UTC+05:00) Islamabad, Karachi",
    utc: ["Asia/Karachi"]
  },
  {
    value: "India Standard Time",
    abbr: "IST",
    offset: 5.5,
    isdst: false,
    text: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
    utc: ["Asia/Calcutta"]
  },
  {
    value: "Sri Lanka Standard Time",
    abbr: "SLST",
    offset: 5.5,
    isdst: false,
    text: "(UTC+05:30) Sri Jayawardenepura",
    utc: ["Asia/Colombo"]
  },
  {
    value: "Nepal Standard Time",
    abbr: "NST",
    offset: 5.75,
    isdst: false,
    text: "(UTC+05:45) Kathmandu",
    utc: ["Asia/Kathmandu"]
  },
  {
    value: "Central Asia Standard Time",
    abbr: "CAST",
    offset: 6,
    isdst: false,
    text: "(UTC+06:00) Astana",
    utc: ["Antarctica/Vostok", "Asia/Almaty", "Asia/Bishkek", "Asia/Qyzylorda", "Asia/Urumqi", "Etc/GMT-6", "Indian/Chagos"]
  },
  {
    value: "Bangladesh Standard Time",
    abbr: "BST",
    offset: 6,
    isdst: false,
    text: "(UTC+06:00) Dhaka",
    utc: ["Asia/Dhaka", "Asia/Thimphu"]
  },
  {
    value: "Ekaterinburg Standard Time",
    abbr: "EST",
    offset: 6,
    isdst: false,
    text: "(UTC+06:00) Ekaterinburg",
    utc: ["Asia/Yekaterinburg"]
  },
  {
    value: "Myanmar Standard Time",
    abbr: "MST",
    offset: 6.5,
    isdst: false,
    text: "(UTC+06:30) Yangon (Rangoon)",
    utc: ["Asia/Rangoon", "Indian/Cocos"]
  },
  {
    value: "SE Asia Standard Time",
    abbr: "SAST",
    offset: 7,
    isdst: false,
    text: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
    utc: ["Antarctica/Davis", "Asia/Bangkok", "Asia/Hovd", "Asia/Jakarta", "Asia/Phnom_Penh", "Asia/Pontianak", "Asia/Saigon", "Asia/Vientiane", "Etc/GMT-7", "Indian/Christmas"]
  },
  {
    value: "N. Central Asia Standard Time",
    abbr: "NCAST",
    offset: 7,
    isdst: false,
    text: "(UTC+07:00) Novosibirsk",
    utc: ["Asia/Novokuznetsk", "Asia/Novosibirsk", "Asia/Omsk"]
  },
  {
    value: "China Standard Time",
    abbr: "CST",
    offset: 8,
    isdst: false,
    text: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
    utc: ["Asia/Hong_Kong", "Asia/Macau", "Asia/Shanghai"]
  },
  {
    value: "North Asia Standard Time",
    abbr: "NAST",
    offset: 8,
    isdst: false,
    text: "(UTC+08:00) Krasnoyarsk",
    utc: ["Asia/Krasnoyarsk"]
  },
  {
    value: "Singapore Standard Time",
    abbr: "MPST",
    offset: 8,
    isdst: false,
    text: "(UTC+08:00) Kuala Lumpur, Singapore",
    utc: ["Asia/Brunei", "Asia/Kuala_Lumpur", "Asia/Kuching", "Asia/Makassar", "Asia/Manila", "Asia/Singapore", "Etc/GMT-8"]
  },
  {
    value: "W. Australia Standard Time",
    abbr: "WAST",
    offset: 8,
    isdst: false,
    text: "(UTC+08:00) Perth",
    utc: ["Antarctica/Casey", "Australia/Perth"]
  },
  {
    value: "Taipei Standard Time",
    abbr: "TST",
    offset: 8,
    isdst: false,
    text: "(UTC+08:00) Taipei",
    utc: ["Asia/Taipei"]
  },
  {
    value: "Ulaanbaatar Standard Time",
    abbr: "UST",
    offset: 8,
    isdst: false,
    text: "(UTC+08:00) Ulaanbaatar",
    utc: ["Asia/Choibalsan", "Asia/Ulaanbaatar"]
  },
  {
    value: "North Asia East Standard Time",
    abbr: "NAEST",
    offset: 9,
    isdst: false,
    text: "(UTC+09:00) Irkutsk",
    utc: ["Asia/Irkutsk"]
  },
  {
    value: "Tokyo Standard Time",
    abbr: "TST",
    offset: 9,
    isdst: false,
    text: "(UTC+09:00) Osaka, Sapporo, Tokyo",
    utc: ["Asia/Dili", "Asia/Jayapura", "Asia/Tokyo", "Etc/GMT-9", "Pacific/Palau"]
  },
  {
    value: "Korea Standard Time",
    abbr: "KST",
    offset: 9,
    isdst: false,
    text: "(UTC+09:00) Seoul",
    utc: ["Asia/Pyongyang", "Asia/Seoul"]
  },
  {
    value: "Cen. Australia Standard Time",
    abbr: "CAST",
    offset: 9.5,
    isdst: false,
    text: "(UTC+09:30) Adelaide",
    utc: ["Australia/Adelaide", "Australia/Broken_Hill"]
  },
  {
    value: "AUS Central Standard Time",
    abbr: "ACST",
    offset: 9.5,
    isdst: false,
    text: "(UTC+09:30) Darwin",
    utc: ["Australia/Darwin"]
  },
  {
    value: "E. Australia Standard Time",
    abbr: "EAST",
    offset: 10,
    isdst: false,
    text: "(UTC+10:00) Brisbane",
    utc: ["Australia/Brisbane", "Australia/Lindeman"]
  },
  {
    value: "AUS Eastern Standard Time",
    abbr: "AEST",
    offset: 10,
    isdst: false,
    text: "(UTC+10:00) Canberra, Melbourne, Sydney",
    utc: ["Australia/Melbourne", "Australia/Sydney"]
  },
  {
    value: "West Pacific Standard Time",
    abbr: "WPST",
    offset: 10,
    isdst: false,
    text: "(UTC+10:00) Guam, Port Moresby",
    utc: ["Antarctica/DumontDUrville", "Etc/GMT-10", "Pacific/Guam", "Pacific/Port_Moresby", "Pacific/Saipan", "Pacific/Truk"]
  },
  {
    value: "Tasmania Standard Time",
    abbr: "TST",
    offset: 10,
    isdst: false,
    text: "(UTC+10:00) Hobart",
    utc: ["Australia/Currie", "Australia/Hobart"]
  },
  {
    value: "Yakutsk Standard Time",
    abbr: "YST",
    offset: 10,
    isdst: false,
    text: "(UTC+10:00) Yakutsk",
    utc: ["Asia/Chita", "Asia/Khandyga", "Asia/Yakutsk"]
  },
  {
    value: "Central Pacific Standard Time",
    abbr: "CPST",
    offset: 11,
    isdst: false,
    text: "(UTC+11:00) Solomon Is., New Caledonia",
    utc: ["Antarctica/Macquarie", "Etc/GMT-11", "Pacific/Efate", "Pacific/Guadalcanal", "Pacific/Kosrae", "Pacific/Noumea", "Pacific/Ponape"]
  },
  {
    value: "Vladivostok Standard Time",
    abbr: "VST",
    offset: 11,
    isdst: false,
    text: "(UTC+11:00) Vladivostok",
    utc: ["Asia/Sakhalin", "Asia/Ust-Nera", "Asia/Vladivostok"]
  },
  {
    value: "New Zealand Standard Time",
    abbr: "NZST",
    offset: 12,
    isdst: false,
    text: "(UTC+12:00) Auckland, Wellington",
    utc: ["Antarctica/McMurdo", "Pacific/Auckland"]
  },
  {
    value: "UTC+12",
    abbr: "U",
    offset: 12,
    isdst: false,
    text: "(UTC+12:00) Coordinated Universal Time+12",
    utc: ["Etc/GMT-12", "Pacific/Funafuti", "Pacific/Kwajalein", "Pacific/Majuro", "Pacific/Nauru", "Pacific/Tarawa", "Pacific/Wake", "Pacific/Wallis"]
  },
  {
    value: "Fiji Standard Time",
    abbr: "FST",
    offset: 12,
    isdst: false,
    text: "(UTC+12:00) Fiji",
    utc: ["Pacific/Fiji"]
  },
  {
    value: "Magadan Standard Time",
    abbr: "MST",
    offset: 12,
    isdst: false,
    text: "(UTC+12:00) Magadan",
    utc: ["Asia/Anadyr", "Asia/Kamchatka", "Asia/Magadan", "Asia/Srednekolymsk"]
  },
  {
    value: "Kamchatka Standard Time",
    abbr: "KDT",
    offset: 13,
    isdst: true,
    text: "(UTC+12:00) Petropavlovsk-Kamchatsky - Old"
  },
  {
    value: "Tonga Standard Time",
    abbr: "TST",
    offset: 13,
    isdst: false,
    text: "(UTC+13:00) Nuku'alofa",
    utc: ["Etc/GMT-13", "Pacific/Enderbury", "Pacific/Fakaofo", "Pacific/Tongatapu"]
  },
  {
    value: "Samoa Standard Time",
    abbr: "SST",
    offset: 13,
    isdst: false,
    text: "(UTC+13:00) Samoa",
    utc: ["Pacific/Apia"]
  }
];
export const countryListJson = [
  {
    name: "Afghanistan",
    dialCode: "+93",
    code: "AF"
  },
  {
    name: "Albania",
    dialCode: "+355",
    code: "AL"
  },
  {
    name: "Algeria",
    dialCode: "+213",
    code: "DZ"
  },
  {
    name: "AmericanSamoa",
    dialCode: "+1684",
    code: "AS"
  },
  {
    name: "Andorra",
    dialCode: "+376",
    code: "AD"
  },
  {
    name: "Angola",
    dialCode: "+244",
    code: "AO"
  },
  {
    name: "Anguilla",
    dialCode: "+1264",
    code: "AI"
  },
  {
    name: "Antigua and Barbuda",
    dialCode: "+1268",
    code: "AG"
  },
  {
    name: "Argentina",
    dialCode: "+54",
    code: "AR"
  },
  {
    name: "Armenia",
    dialCode: "+374",
    code: "AM"
  },
  {
    name: "Aruba",
    dialCode: "+297",
    code: "AW"
  },
  {
    name: "Australia",
    dialCode: "+61",
    code: "AU"
  },
  {
    name: "Austria",
    dialCode: "+43",
    code: "AT"
  },
  {
    name: "Azerbaijan",
    dialCode: "+994",
    code: "AZ"
  },
  {
    name: "Bahamas",
    dialCode: "+1242",
    code: "BS"
  },
  {
    name: "Bahrain",
    dialCode: "+973",
    code: "BH"
  },
  {
    name: "Bangladesh",
    dialCode: "+880",
    code: "BD"
  },
  {
    name: "Barbados",
    dialCode: "+1246",
    code: "BB"
  },
  {
    name: "Belarus",
    dialCode: "+375",
    code: "BY"
  },
  {
    name: "Belgium",
    dialCode: "+32",
    code: "BE"
  },
  {
    name: "Belize",
    dialCode: "+501",
    code: "BZ"
  },
  {
    name: "Benin",
    dialCode: "+229",
    code: "BJ"
  },
  {
    name: "Bermuda",
    dialCode: "+1441",
    code: "BM"
  },
  {
    name: "Bhutan",
    dialCode: "+975",
    code: "BT"
  },
  {
    name: "Bosnia and Herzegovina",
    dialCode: "+387",
    code: "BA"
  },
  {
    name: "Botswana",
    dialCode: "+267",
    code: "BW"
  },
  {
    name: "Brazil",
    dialCode: "+55",
    code: "BR"
  },
  {
    name: "British Indian Ocean Territory",
    dialCode: "+246",
    code: "IO"
  },
  {
    name: "Bulgaria",
    dialCode: "+359",
    code: "BG"
  },
  {
    name: "Burkina Faso",
    dialCode: "+226",
    code: "BF"
  },
  {
    name: "Burundi",
    dialCode: "+257",
    code: "BI"
  },
  {
    name: "Cambodia",
    dialCode: "+855",
    code: "KH"
  },
  {
    name: "Cameroon",
    dialCode: "+237",
    code: "CM"
  },
  {
    name: "Canada/United States",
    dialCode: "+1",
    code: "CA"
  },
  {
    name: "Cape Verde",
    dialCode: "+238",
    code: "CV"
  },
  {
    name: "Cayman Islands",
    dialCode: "+ 345",
    code: "KY"
  },
  {
    name: "Central African Republic",
    dialCode: "+236",
    code: "CF"
  },
  {
    name: "Chad",
    dialCode: "+235",
    code: "TD"
  },
  {
    name: "Chile",
    dialCode: "+56",
    code: "CL"
  },
  {
    name: "China",
    dialCode: "+86",
    code: "CN"
  },
  {
    name: "Christmas Island",
    dialCode: "+61",
    code: "CX"
  },
  {
    name: "Colombia",
    dialCode: "+57",
    code: "CO"
  },
  {
    name: "Comoros",
    dialCode: "+269",
    code: "KM"
  },
  {
    name: "Congo",
    dialCode: "+242",
    code: "CG"
  },
  {
    name: "Cook Islands",
    dialCode: "+682",
    code: "CK"
  },
  {
    name: "Costa Rica",
    dialCode: "+506",
    code: "CR"
  },
  {
    name: "Croatia",
    dialCode: "+385",
    code: "HR"
  },
  {
    name: "Cuba",
    dialCode: "+53",
    code: "CU"
  },
  {
    name: "Cyprus",
    dialCode: "+537",
    code: "CY"
  },
  {
    name: "Czech Republic",
    dialCode: "+420",
    code: "CZ"
  },
  {
    name: "Denmark",
    dialCode: "+45",
    code: "DK"
  },
  {
    name: "Djibouti",
    dialCode: "+253",
    code: "DJ"
  },
  {
    name: "Dominica",
    dialCode: "+1767",
    code: "DM"
  },
  {
    name: "Dominican Republic",
    dialCode: "+1849",
    code: "DO"
  },
  {
    name: "Ecuador",
    dialCode: "+593",
    code: "EC"
  },
  {
    name: "Egypt",
    dialCode: "+20",
    code: "EG"
  },
  {
    name: "El Salvador",
    dialCode: "+503",
    code: "SV"
  },
  {
    name: "Equatorial Guinea",
    dialCode: "+240",
    code: "GQ"
  },
  {
    name: "Eritrea",
    dialCode: "+291",
    code: "ER"
  },
  {
    name: "Estonia",
    dialCode: "+372",
    code: "EE"
  },
  {
    name: "Ethiopia",
    dialCode: "+251",
    code: "ET"
  },
  {
    name: "Faroe Islands",
    dialCode: "+298",
    code: "FO"
  },
  {
    name: "Fiji",
    dialCode: "+679",
    code: "FJ"
  },
  {
    name: "Finland",
    dialCode: "+358",
    code: "FI"
  },
  {
    name: "France",
    dialCode: "+33",
    code: "FR"
  },
  {
    name: "French Guiana",
    dialCode: "+594",
    code: "GF"
  },
  {
    name: "French Polynesia",
    dialCode: "+689",
    code: "PF"
  },
  {
    name: "Gabon",
    dialCode: "+241",
    code: "GA"
  },
  {
    name: "Gambia",
    dialCode: "+220",
    code: "GM"
  },
  {
    name: "Georgia",
    dialCode: "+995",
    code: "GE"
  },
  {
    name: "Germany",
    dialCode: "+49",
    code: "DE"
  },
  {
    name: "Ghana",
    dialCode: "+233",
    code: "GH"
  },
  {
    name: "Gibraltar",
    dialCode: "+350",
    code: "GI"
  },
  {
    name: "Greece",
    dialCode: "+30",
    code: "GR"
  },
  {
    name: "Greenland",
    dialCode: "+299",
    code: "GL"
  },
  {
    name: "Grenada",
    dialCode: "+1473",
    code: "GD"
  },
  {
    name: "Guadeloupe",
    dialCode: "+590",
    code: "GP"
  },
  {
    name: "Guam",
    dialCode: "+1671",
    code: "GU"
  },
  {
    name: "Guatemala",
    dialCode: "+502",
    code: "GT"
  },
  {
    name: "Guinea",
    dialCode: "+224",
    code: "GN"
  },
  {
    name: "Guinea-Bissau",
    dialCode: "+245",
    code: "GW"
  },
  {
    name: "Guyana",
    dialCode: "+595",
    code: "GY"
  },
  {
    name: "Haiti",
    dialCode: "+509",
    code: "HT"
  },
  {
    name: "Honduras",
    dialCode: "+504",
    code: "HN"
  },
  {
    name: "Hungary",
    dialCode: "+36",
    code: "HU"
  },
  {
    name: "Iceland",
    dialCode: "+354",
    code: "IS"
  },
  {
    name: "India",
    dialCode: "+91",
    code: "IN"
  },
  {
    name: "Indonesia",
    dialCode: "+62",
    code: "ID"
  },
  {
    name: "Iraq",
    dialCode: "+964",
    code: "IQ"
  },
  {
    name: "Ireland",
    dialCode: "+353",
    code: "IE"
  },
  {
    name: "Israel",
    dialCode: "+972",
    code: "IL"
  },
  {
    name: "Italy",
    dialCode: "+39",
    code: "IT"
  },
  {
    name: "Jamaica",
    dialCode: "+1876",
    code: "JM"
  },
  {
    name: "Japan",
    dialCode: "+81",
    code: "JP"
  },
  {
    name: "Jordan",
    dialCode: "+962",
    code: "JO"
  },
  {
    name: "Kazakhstan",
    dialCode: "+7 7",
    code: "KZ"
  },
  {
    name: "Kenya",
    dialCode: "+254",
    code: "KE"
  },
  {
    name: "Kiribati",
    dialCode: "+686",
    code: "KI"
  },
  {
    name: "Kuwait",
    dialCode: "+965",
    code: "KW"
  },
  {
    name: "Kyrgyzstan",
    dialCode: "+996",
    code: "KG"
  },
  {
    name: "Latvia",
    dialCode: "+371",
    code: "LV"
  },
  {
    name: "Lebanon",
    dialCode: "+961",
    code: "LB"
  },
  {
    name: "Lesotho",
    dialCode: "+266",
    code: "LS"
  },
  {
    name: "Liberia",
    dialCode: "+231",
    code: "LR"
  },
  {
    name: "Liechtenstein",
    dialCode: "+423",
    code: "LI"
  },
  {
    name: "Lithuania",
    dialCode: "+370",
    code: "LT"
  },
  {
    name: "Luxembourg",
    dialCode: "+352",
    code: "LU"
  },
  {
    name: "Madagascar",
    dialCode: "+261",
    code: "MG"
  },
  {
    name: "Malawi",
    dialCode: "+265",
    code: "MW"
  },
  {
    name: "Malaysia",
    dialCode: "+60",
    code: "MY"
  },
  {
    name: "Maldives",
    dialCode: "+960",
    code: "MV"
  },
  {
    name: "Mali",
    dialCode: "+223",
    code: "ML"
  },
  {
    name: "Malta",
    dialCode: "+356",
    code: "MT"
  },
  {
    name: "Marshall Islands",
    dialCode: "+692",
    code: "MH"
  },
  {
    name: "Martinique",
    dialCode: "+596",
    code: "MQ"
  },
  {
    name: "Mauritania",
    dialCode: "+222",
    code: "MR"
  },
  {
    name: "Mauritius",
    dialCode: "+230",
    code: "MU"
  },
  {
    name: "Mayotte",
    dialCode: "+262",
    code: "YT"
  },
  {
    name: "Mexico",
    dialCode: "+52",
    code: "MX"
  },
  {
    name: "Monaco",
    dialCode: "+377",
    code: "MC"
  },
  {
    name: "Mongolia",
    dialCode: "+976",
    code: "MN"
  },
  {
    name: "Montenegro",
    dialCode: "+382",
    code: "ME"
  },
  {
    name: "Montserrat",
    dialCode: "+1664",
    code: "MS"
  },
  {
    name: "Morocco",
    dialCode: "+212",
    code: "MA"
  },
  {
    name: "Myanmar",
    dialCode: "+95",
    code: "MM"
  },
  {
    name: "Namibia",
    dialCode: "+264",
    code: "NA"
  },
  {
    name: "Nauru",
    dialCode: "+674",
    code: "NR"
  },
  {
    name: "Nepal",
    dialCode: "+977",
    code: "NP"
  },
  {
    name: "Netherlands",
    dialCode: "+31",
    code: "NL"
  },
  {
    name: "Netherlands Antilles",
    dialCode: "+599",
    code: "AN"
  },
  {
    name: "New Caledonia",
    dialCode: "+687",
    code: "NC"
  },
  {
    name: "New Zealand",
    dialCode: "+64",
    code: "NZ"
  },
  {
    name: "Nicaragua",
    dialCode: "+505",
    code: "NI"
  },
  {
    name: "Niger",
    dialCode: "+227",
    code: "NE"
  },
  {
    name: "Nigeria",
    dialCode: "+234",
    code: "NG"
  },
  {
    name: "Niue",
    dialCode: "+683",
    code: "NU"
  },
  {
    name: "Norfolk Island",
    dialCode: "+672",
    code: "NF"
  },
  {
    name: "Northern Mariana Islands",
    dialCode: "+1670",
    code: "MP"
  },
  {
    name: "Norway",
    dialCode: "+47",
    code: "NO"
  },
  {
    name: "Oman",
    dialCode: "+968",
    code: "OM"
  },
  {
    name: "Pakistan",
    dialCode: "+92",
    code: "PK"
  },
  {
    name: "Palau",
    dialCode: "+680",
    code: "PW"
  },
  {
    name: "Panama",
    dialCode: "+507",
    code: "PA"
  },
  {
    name: "Papua New Guinea",
    dialCode: "+675",
    code: "PG"
  },
  {
    name: "Paraguay",
    dialCode: "+595",
    code: "PY"
  },
  {
    name: "Peru",
    dialCode: "+51",
    code: "PE"
  },
  {
    name: "Philippines",
    dialCode: "+63",
    code: "PH"
  },
  {
    name: "Poland",
    dialCode: "+48",
    code: "PL"
  },
  {
    name: "Portugal",
    dialCode: "+351",
    code: "PT"
  },
  {
    name: "Puerto Rico",
    dialCode: "+1939",
    code: "PR"
  },
  {
    name: "Qatar",
    dialCode: "+974",
    code: "QA"
  },
  {
    name: "Romania",
    dialCode: "+40",
    code: "RO"
  },
  {
    name: "Rwanda",
    dialCode: "+250",
    code: "RW"
  },
  {
    name: "Samoa",
    dialCode: "+685",
    code: "WS"
  },
  {
    name: "San Marino",
    dialCode: "+378",
    code: "SM"
  },
  {
    name: "Saudi Arabia",
    dialCode: "+966",
    code: "SA"
  },
  {
    name: "Senegal",
    dialCode: "+221",
    code: "SN"
  },
  {
    name: "Serbia",
    dialCode: "+381",
    code: "RS"
  },
  {
    name: "Seychelles",
    dialCode: "+248",
    code: "SC"
  },
  {
    name: "Sierra Leone",
    dialCode: "+232",
    code: "SL"
  },
  {
    name: "Singapore",
    dialCode: "+65",
    code: "SG"
  },
  {
    name: "Slovakia",
    dialCode: "+421",
    code: "SK"
  },
  {
    name: "Slovenia",
    dialCode: "+386",
    code: "SI"
  },
  {
    name: "Solomon Islands",
    dialCode: "+677",
    code: "SB"
  },
  {
    name: "South Africa",
    dialCode: "+27",
    code: "ZA"
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    dialCode: "+500",
    code: "GS"
  },
  {
    name: "Spain",
    dialCode: "+34",
    code: "ES"
  },
  {
    name: "Sri Lanka",
    dialCode: "+94",
    code: "LK"
  },
  {
    name: "Sudan",
    dialCode: "+249",
    code: "SD"
  },
  {
    name: "Suriname",
    dialCode: "+597",
    code: "SR"
  },
  {
    name: "Swaziland",
    dialCode: "+268",
    code: "SZ"
  },
  {
    name: "Sweden",
    dialCode: "+46",
    code: "SE"
  },
  {
    name: "Switzerland",
    dialCode: "+41",
    code: "CH"
  },
  {
    name: "Tajikistan",
    dialCode: "+992",
    code: "TJ"
  },
  {
    name: "Thailand",
    dialCode: "+66",
    code: "TH"
  },
  {
    name: "Togo",
    dialCode: "+228",
    code: "TG"
  },
  {
    name: "Tokelau",
    dialCode: "+690",
    code: "TK"
  },
  {
    name: "Tonga",
    dialCode: "+676",
    code: "TO"
  },
  {
    name: "Trinidad and Tobago",
    dialCode: "+1868",
    code: "TT"
  },
  {
    name: "Tunisia",
    dialCode: "+216",
    code: "TN"
  },
  {
    name: "Turkey",
    dialCode: "+90",
    code: "TR"
  },
  {
    name: "Turkmenistan",
    dialCode: "+993",
    code: "TM"
  },
  {
    name: "Turks and Caicos Islands",
    dialCode: "+1649",
    code: "TC"
  },
  {
    name: "Tuvalu",
    dialCode: "+688",
    code: "TV"
  },
  {
    name: "Uganda",
    dialCode: "+256",
    code: "UG"
  },
  {
    name: "Ukraine",
    dialCode: "+380",
    code: "UA"
  },
  {
    name: "United Arab Emirates",
    dialCode: "+971",
    code: "AE"
  },
  {
    name: "United Kingdom",
    dialCode: "+44",
    code: "GB"
  },
  {
    name: "United States/Canada",
    dialCode: "+1",
    code: "US"
  },
  {
    name: "Uruguay",
    dialCode: "+598",
    code: "UY"
  },
  {
    name: "Uzbekistan",
    dialCode: "+998",
    code: "UZ"
  },
  {
    name: "Vanuatu",
    dialCode: "+678",
    code: "VU"
  },
  {
    name: "Wallis and Futuna",
    dialCode: "+681",
    code: "WF"
  },
  {
    name: "Yemen",
    dialCode: "+967",
    code: "YE"
  },
  {
    name: "Zambia",
    dialCode: "+260",
    code: "ZM"
  },
  {
    name: "Zimbabwe",
    dialCode: "+263",
    code: "ZW"
  },
  {
    name: "land Islands",
    dialCode: "+358",
    code: "AX"
  },
  {
    name: "Antarctica",
    dialCode: "+672",
    code: "AQ"
  },
  {
    name: "Bolivia, Plurinational State of",
    dialCode: "+591",
    code: "BO"
  },
  {
    name: "Brunei Darussalam",
    dialCode: "+673",
    code: "BN"
  },
  {
    name: "Cocos (Keeling) Islands",
    dialCode: "+61",
    code: "CC"
  },
  {
    name: "Congo, The Democratic Republic of the",
    dialCode: "+243",
    code: "CD"
  },
  {
    name: "Cote d'Ivoire",
    dialCode: "+225",
    code: "CI"
  },
  {
    name: "Falkland Islands (Malvinas)",
    dialCode: "+500",
    code: "FK"
  },
  {
    name: "Holy See (Vatican City State)",
    dialCode: "+379",
    code: "VA"
  },
  {
    name: "Hong Kong",
    dialCode: "+852",
    code: "HK"
  },
  {
    name: "Iran, Islamic Republic of",
    dialCode: "+98",
    code: "IR"
  },
  {
    name: "Korea, Democratic People's Republic of",
    dialCode: "+850",
    code: "KP"
  },
  {
    name: "Korea, Republic of",
    dialCode: "+82",
    code: "KR"
  },
  {
    name: "Lao People's Democratic Republic",
    dialCode: "+856",
    code: "LA"
  },
  {
    name: "Libyan Arab Jamahiriya",
    dialCode: "+218",
    code: "LY"
  },
  {
    name: "Macao",
    dialCode: "+853",
    code: "MO"
  },
  {
    name: "Macedonia, The Former Yugoslav Republic of",
    dialCode: "+389",
    code: "MK"
  },
  {
    name: "Micronesia, Federated States of",
    dialCode: "+691",
    code: "FM"
  },
  {
    name: "Moldova, Republic of",
    dialCode: "+373",
    code: "MD"
  },
  {
    name: "Mozambique",
    dialCode: "+258",
    code: "MZ"
  },
  {
    name: "Palestinian Territory, Occupied",
    dialCode: "+970",
    code: "PS"
  },
  {
    name: "Pitcairn",
    dialCode: "+872",
    code: "PN"
  },
  {
    name: "Réunion",
    dialCode: "+262",
    code: "RE"
  },
  {
    name: "Russia",
    dialCode: "+7",
    code: "RU"
  },
  {
    name: "Saint Barthélemy",
    dialCode: "+590",
    code: "BL"
  },
  {
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    dialCode: "+290",
    code: "SH"
  },
  {
    name: "Saint Kitts and Nevis",
    dialCode: "+1869",
    code: "KN"
  },
  {
    name: "Saint Lucia",
    dialCode: "+1758",
    code: "LC"
  },
  {
    name: "Saint Martin",
    dialCode: "+590",
    code: "MF"
  },
  {
    name: "Saint Pierre and Miquelon",
    dialCode: "+508",
    code: "PM"
  },
  {
    name: "Saint Vincent and the Grenadines",
    dialCode: "+1784",
    code: "VC"
  },
  {
    name: "Sao Tome and Principe",
    dialCode: "+239",
    code: "ST"
  },
  {
    name: "Somalia",
    dialCode: "+252",
    code: "SO"
  },
  {
    name: "Svalbard and Jan Mayen",
    dialCode: "+47",
    code: "SJ"
  },
  {
    name: "Syrian Arab Republic",
    dialCode: "+963",
    code: "SY"
  },
  {
    name: "Taiwan, Province of China",
    dialCode: "+886",
    code: "TW"
  },
  {
    name: "Tanzania, United Republic of",
    dialCode: "+255",
    code: "TZ"
  },
  {
    name: "Timor-Leste",
    dialCode: "+670",
    code: "TL"
  },
  {
    name: "Venezuela, Bolivarian Republic of",
    dialCode: "+58",
    code: "VE"
  },
  {
    name: "Viet Nam",
    dialCode: "+84",
    code: "VN"
  },
  {
    name: "Virgin Islands, British",
    dialCode: "+1284",
    code: "VG"
  },
  {
    name: "Virgin Islands, U.S.",
    dialCode: "+1340",
    code: "VI"
  }
];

export const listOfDataCompliances = [
  "Australian Government IRAP",
  "Canadian Privacy Laws",
  "CDSA",
  "CCSL (IRAP)",
  "Cloud Security Alliance CCM",
  "COPPA",
  // "CSA STAR Certification",
  "EU Model Clauses",
  "EU - US Privacy Shield",
  "FIPS 140-2",
  "FISMA",
  "GDPR (Compliant-ready)",
  "HIPAA/HITECH",
  "ISO 22301",
  // "ISO/IEC 27001/27002",
  // "ISO/IEC 27017",
  "ISO/IEC 27018",
  //  "OpenID Certification",
  // "PCI DSS",
  "SOC 1/SSAE 16/ISAE 3402 and SOC 2",
  "Spain ENS",
  "United Kingdom G-Cloud",
  "WCAG 2.0"
];
export const listOfSecurityCompliances = [
  "ISO/IEC 27001:2013",
  "ISO/IEC 27017:2015",
  "SOC 2 (Type II)",
  "ISAE 3000",
  "NIST Cybersecurity Framework",
  "CSA Star CCM",
  "CIS Critical Security Controls",
  // "PCI DSS Compliant",
  "OpenID"
];

export interface SmtpProviderSchema {
  name: string;
  smtpHost: string;
  smtpPort: number;
  enableSSL: boolean;
  source: string;
  id: string;
  username?: string;
  userid?: string;
  email?: string;
  isHttpProvider?: boolean;
}

export interface SmtpOptionSchema {
  optionID: string;
  optionName: string;
  optionType: string;
  optionValue: string | number;
  errorMessage?: string;
  RequireValue: string;
  tooltip?: string;
}

export interface SmtpOptionsSchema {
  [option: string]: SmtpOptionSchema;
}

export const SMTP_OPTION_NAMES: { [name: string]: string } = {
  FROM_NAME: "FromName",
  FROM_EMAIL: "FromEmailId",
  USERNAME: "UserName",
  PASSWORD: "Password",
  HOST: "SmtpHost",
  PORT: "SmtpPort",
  SSL: "IsSsl",
  PROVIDERS: "SMTPProviders",
  KEY: "Key",
  SECRET: "Secret"
};

export const SMTP_PROVIDERS: SmtpProviderSchema[] = [
  {
    name: "Amazon SES (US East)",
    id: "aws-us-east",
    smtpHost: "email-smtp.us-east-1.amazonaws.com",
    smtpPort: 587,
    enableSSL: true,
    source: "aws"
  },
  {
    name: "Amazon SES (US West)",
    id: "aws-us-west",
    smtpHost: "email-smtp.us-west-2.amazonaws.com",
    smtpPort: 587,
    enableSSL: true,
    source: "aws"
  },
  {
    name: "Amazon SES (EU)",
    id: "aws-eu",
    smtpHost: "email-smtp.eu-west-1.amazonaws.com",
    smtpPort: 587,
    enableSSL: true,
    source: "aws"
  },
  {
    name: "Gmail",
    id: "gmail",
    smtpHost: "smtp.gmail.com",
    smtpPort: 587,
    enableSSL: true,
    source: "gmail"
  },
  {
    name: "Mandrill",
    id: "mandrill",
    smtpHost: "smtp.mandrillapp.com",
    smtpPort: 587,
    enableSSL: true,
    source: "mandrill"
  },
  {
    name: "Rackspace-mailgun",
    id: "rackspace-mailgun",
    smtpHost: "smtp.mailgun.org",
    smtpPort: 587,
    enableSSL: true,
    source: "mailgun"
  },
  {
    name: "SendGrid",
    id: "sendgrid",
    smtpHost: "smtp.sendgrid.net",
    smtpPort: 587,
    enableSSL: true,
    source: "sendgrid"
  },
  {
    name: "Yahoo",
    id: "yahoo",
    smtpHost: "smtp.mail.yahoo.com",
    smtpPort: 587,
    enableSSL: true,
    source: "yahoo"
  },
  {
    name: "Custom SMTP Provider",
    id: "custom",
    smtpHost: "",
    smtpPort: 0,
    enableSSL: false,
    source: "default"
  },
  {
    name: "Custom HTTP Mail Provider",
    id: "customhttp",
    smtpHost: "",
    smtpPort: 0,
    enableSSL: false,
    source: "default",
    isHttpProvider: true
  }
];
export const SMTP_OPTIONS: SmtpOptionsSchema = {
  [SMTP_OPTION_NAMES.PROVIDERS]: {
    optionID: "SMTPProviders",
    optionName: "SMTP Providers",
    optionType: "option",
    optionValue: "",
    RequireValue: "both"
  },
  [SMTP_OPTION_NAMES.KEY]: {
    optionID: "Key",
    optionName: "Key",
    optionType: "text",
    optionValue: "",
    RequireValue: "key",
    tooltip: "Configure mailazy to get Key"
  },
  [SMTP_OPTION_NAMES.SECRET]: {
    optionID: "Secret",
    optionName: "Secret",
    optionType: "text",
    optionValue: "",
    RequireValue: "key",
    tooltip: "Configure mailazy to get Secret"
  },
  [SMTP_OPTION_NAMES.HOST]: {
    optionID: "SMTPHost",
    optionName: "SMTP Host",
    optionType: "text",
    optionValue: "",
    RequireValue: "withoutkey"
  },
  [SMTP_OPTION_NAMES.PORT]: {
    optionID: "SMTPPort",
    optionName: "SMTP Port",
    optionType: "text",
    optionValue: 0,
    RequireValue: "withoutkey"
  },
  [SMTP_OPTION_NAMES.FROM_NAME]: {
    optionID: "FromName",
    optionName: "From Name",
    optionType: "text",
    optionValue: "",
    RequireValue: "both"
  },
  [SMTP_OPTION_NAMES.FROM_EMAIL]: {
    optionID: "FromEmail",
    optionName: "From Email Address",
    optionType: "text",
    optionValue: "",
    RequireValue: "both"
  },
  [SMTP_OPTION_NAMES.USERNAME]: {
    optionID: "SMTPUsername",
    optionName: "SMTP User Name",
    optionType: "text",
    optionValue: "",
    RequireValue: "withoutkey"
  },
  [SMTP_OPTION_NAMES.PASSWORD]: {
    optionID: "SMTPPassword",
    optionName: "SMTP Password",
    optionType: "password",
    optionValue: "",
    RequireValue: "withoutkey"
  },
  [SMTP_OPTION_NAMES.SSL]: {
    optionID: "EnableSSL",
    optionName: "Enable SSL",
    optionType: "checkbox",
    optionValue: "false",
    RequireValue: "withoutkey"
  }
};

export const INT32_MAX = 2147483647;
export const MAX_PERMISSION_LENGTH = 500;

// Sonar Qube refactoring
export const MONTH_DATE_YEAR_FORMAT = "MM/DD/YYYY";
export const SCRIPT_TYPE_JAVASCRIPT = "text/javascript_application/x-javascript";

export const ExportData = {
  PROFILE: "profile",
  CUSTOM_OBJECT: "customobject",
  PROFILE_AND_CUSTOM_OBJECT: "profile-customobject"
};

export const FrequencyPayloadValues = {
  Daily: "Day",
  Weekly: "Week",
  Monthly: "Month"
};

export const FrequencyOptions = {
  DAILY: "Daily",
  WEEKLY: "Weekly",
  MONTHLY: "Monthly"
};

export const Days = {
  MONDAY: "Monday",
  TUESDAY: "Tuesday",
  WEDNESDAY: "Wednesday",
  THURSDAY: "Thursday",
  FRIDAY: "Friday",
  SATURDAY: "Saturday",
  SUNDAY: "Sunday"
};

export const DEFAULT_FREQUENCY_FOR_ON_DEMAND_EXPORT = FrequencyPayloadValues.Weekly;
export const DEFAULT_DAY_FOR_WEEKLY_EXPORT = Days.MONDAY;

export const INTEGRATION_EVENTS = [
  "login",
  "register",
  "updateProfile",
  "resetPassword",
  "changePassword",
  "emailVerification",
  "addEmail",
  "removeEmail",
  "blockAccount",
  "deleteAccount",
  "setUsername",
  "assignRoles",
  "unassignRoles",
  "SetPassword",
  "linkAccount",
  "unlinkAccount",
  "updatePhoneId",
  "verifyPhoneNumber",
  "updateCustomobject",
  "deleteCustomObject",
  "createCustomObject",
  "invalidateEmailVerification"
].sort((s, f) => (s.toLowerCase() < f.toLowerCase() ? -1 : 1));

export const bodyCenter: React.CSSProperties = {
  position: "fixed",
  left: "50%",
  top: "50%",
  transform: "translate(-50%, -50%)"
};
export const sectionCenter: React.CSSProperties = {
  position: "absolute",
  left: "50%",
  top: "50%",
  transform: "translate(-50%, -50%)"
};

export const CDNFILE_UPLOAD_DOMAIN = {
  fileStack: "https://cdn.filestackcontent.com/"
};

export enum PlaceholderLength {
  FULL = "full",
  VERY_LONG = "very long",
  LONG = "long",
  MEDIUM = "medium",
  SHORT = "short",
  VERY_SHORT = "very short"
}

export const docsDescMap = {
  main: {
    "Bot Protection": {
      docLink: docsLink["Bot Protection"],
      docKey: "BOT_PROTECTIONS_HEADER"
    },
    "API Security": {
      docLink: docsLink["Bot Protection"],
      docKey: "BOT_PROTECTION_HEADER"
    },
    "IP Access Management": {
      docLink: docsLink["IP Access Management"],
      docKey: "IP_ACCESS_HEADER"
    },
    "Domain Access Management": {
      docLink: docsLink["Domain Access Management"],
      docKey: "ACCESS_RESTRICTION_HEADER"
    },
    "Email Provider": {
      docLink: docsLink["Email Provider"],
      docKey: "EMAIL_CONFIGURATION_TAB_DESCRIPTION"
    },
    "Security Questions": {
      docLink: docsLink["Security Questions"],
      docKey: "SECURITY_QUESTION_HEADER"
    },
    "Privacy and Consent": {
      docLink: docsLink["Privacy and Consent"],
      docKey: "PRIVACY_CONSENT_HEADER"
    },
    "SMS Providers": {
      docLink: docsLink["SMS Provider"],
      docKey: "SMS_CONFIGURATION_HEADER"
    },
    "Attack Protection": {
      docLink: docsLink["Attack Protection"],
      docKey: "ATTACK_PROTECTION_HEADER"
    },
    "PIN Authentication": {
      docLink: docsLink["PIN Authentication"],
      docKey: "PIN_AUTH_HEADER"
    },
    "Platform Security": {
      docLink: docsLink["Platform Security"],
      docKey: "PLATFORM_SECURITY_HEADER"
    },
    "Password Policy": {
      docLink: docsLink["Password Policy"],
      docKey: "PASSWORD_POLICY_HEADER"
    },
    "Email Templates": {
      docLink: docsLink["Email Templates"],
      docKey: "EMAIL_TEMPLATES_HEADER"
    },
    "SMS Templates": {
      docLink: docsLink["SMS Templates"],
      docKey: "SMS_TEMPLATES_HEADER"
    },
    "Multi Factor Authentication": {
      docLink: docsLink["Multi Factor Authentication"],
      docKey: "MULTI_FACTOR_HEADER"
    },
    "Session Management": {
      docLink: docsLink["Session Management"],
      docKey: "SESSION_MANAGEMENT_HEADER"
    },
    "Risk-Based Authentication": {
      docLink: docsLink["Risk-Based Authentication"],
      docKey: "RISK_BASED_HEADER"
    },
    "Step-up Authentication": {
      docLink: "",
      docKey: ""
    },
    "Outbound SSO": {
      docLink: "",
      docKey: "INTEGRATION_HEADER"
    },
    "SSO Integrations": {
      docLink: docsLink["SSO Integrations"],
      docKey: "SSO_INTEGRATION_HEADER"
    },
    "Third Party Software": {
      docLink: docsLink["Third Party Software"],
      docKey: "THIRD_PARTY_SOFTWARE_HEADER"
    },
    "Audit Log Integration": {
      docLink: docsLink["Audit Log Integration"],
      docKey: "AUDIT_LOG_INTEGRATION_DESC"
    },
    Roles: {
      docLink: docsLink["Roles & Permissions"],
      docKey: "MANAGE_ROLE_PERMISSION_HEADER"
    },
    Workflows: {
      docLink: docsLink.Workflows,
      docKey: "MANAGE_ROLE_PERMISSION_HEADER"
    },
    "Consent Management": {
      docLink: docsLink["Consent Management"],
      docKey: "CONSENT_OPTION_DESCRIPTION"
    },
    "Privacy Versioning": {
      docLink: docsLink["Privacy Versioning"],
      docKey: "PRIVACY_VERSIONING_HEADER"
    },
    "Age Verification": {
      docKey: "AGE_VERIFICATION_DESC",
      docLink: docsLink["Age Verification"]
    },
    "New Workflow": {
      docLink: docsLink["New Workflow"],
      docKey: "NEW_WORKFLOW_DESCRIPTION"
    },
    "Workflow Templates": {
      docLink: docsLink["Workflow Templates"],
      docKey: "NEW_WORKFLOW_TEMPLATES_DESCRIPTION"
    },
    "API Credentials": {
      docKey: "API_CREDENTIALS_HEADER",
      docLink: docsLink["API configuration"]
    },

    "Email Passcode": {
      docLink: docsLink.EMAIL_PASSCODE,
      docKey: "EMAIL_PASSCODE_HEADER"
    },
    "SMS Passcode": {
      docLink: docsLink.SMS_PASSCODE,
      docKey: "SMS_PASSCODE_HEADER_TEXT"
    },
    "Authenticator Apps": {
      docLink: docsLink.GOOGLE_AUTHENTICATOR,
      docKey: "GOOGLE_AUTHENTICATOR_HEADER"
    },
    "MFA Security Questions": {
      docLink: docsLink.SECURITY_QUESTION,
      docKey: "MFA_SECURITY_QUESTION_HEADER"
    },
    "Whitelist Domain": {
      docLink: docsLink["Tenant Settings"],
      docKey: "WEB_APPS_HEADER"
    },
    Webhook: {
      docLink: docsLink.Webhook,
      docKey: "WEB_HOOKS_TAB_DESCRIPTION"
    },
    "Social Providers": {
      docLink: docsLink["Social Providers"],
      docKey: "SOCIAL_PROVIDER_HEADER"
    },
    "Manage Team Member": {
      docLink: docsLink["Manage Team Member"],
      docKey: "TEAM_MANAGEMENT_HEADER"
    },
    "Audit Logs": {
      docLink: docsLink["Audit Logs"],
      docKey: "AUDIT_LOGS_DESC"
    },
    "Manage Customers": {
      docLink: docsLink["Manage Users"],
      docKey: "MANAGE_CUSTOMERS_DESC"
    },
    "Account API Keys": {
      docLink: docsLink.ACCOUNT_API_KEYS,
      docKey: "ACCOUNT_API_KEY_CARD_DESCRIPTION"
    },
    "Additional API Secret(s)": {
      docLink: docsLink.ADDITIONAL_API_SECRETS,
      docKey: "ADDITIONAL_API_SECRETS_CARD_DESCRIPTION"
    },
    "Your Tenants": {
      docLink: docsLink["Your Tenants"],
      docKey: "ALL_SITES_PAGE_DESCRIPTION"
    },
    "SOTT (Mobile App)": {
      docLink: docsLink["SOTT (Mobile App)"],
      docKey: "MOBILE_APPS_HEADER"
    },
    "Custom IDPs": {
      docLink: docsLink["Custom IDPs"],
      docKey: "CUSTOM_IDP_DESCRIPTION"
    },
    "Team Management": {
      docLink: docsLink["Team Management"],
      docKey: "TEAM_MANAGEMENT_DESCRIPTION"
    },
    "User Audit Logs": {
      docLink: docsLink["User Audit Logs"],
      docKey: "CONSUMER_AUDIT_LOGS_RECENT_ACCOUNT_ACTIVITIES"
    },
    "Platform Intelligence": {
      docLink: docsLink["Platform Intelligence"],
      docKey: "PLATFORM_INTELLIGENCE_DESCRIPTION"
    },
    "User Analytics": {
      docLink: docsLink["User Analytics"],
      docKey: "CUSTOMER_ANAYLTICS_DESCRIPTION"
    },
    "Platform Analytics": {
      docLink: docsLink["Platform Intelligence"],
      docKey: "PLATFORM_ANAYLTICS_DESCRIPTION"
    },
    "User Segmentations": {
      docLink: docsLink["User Segmentations"],
      docKey: "CUSTOMER_SEGMENTATION_ADVANCED_SEGMENTATION_TAB_DESCRIPTION"
    },
    "Data Export": {
      docLink: docsLink["Data Export"],
      docKey: "DATA_EXPORT_TAB_DESCRIPTION"
    },
    "Hosted Pages": {
      docLink: docsLink["Hosted Pages"],
      docKey: "SELF_HOSTED_PAGE_HEADING"
    },
    "Auth Studio": {
      docLink: docsLink["Auth Studio"],
      docKey: "SELF_HOSTED_PAGE_HEADING"
    },
    Forms: {
      docLink: docsLink.Forms,
      docKey: "FORMS_DESCRIPTION"
    },
    "My Account": {
      docLink: docsLink.ACCOUNT_PROFILE,
      docKey: "MY_ACCOUNT_DESC"
    },
    "Get Support": {
      docLink: docsLink["Get Support"],
      docKey: "SUPPORT_TICKET_DESC"
    },
    "Tenant Settings": {
      docLink: docsLink["Tenant Settings"],
      docKey: "TENANT_SETTINGS_DESC"
    },
    Billing: {
      docLink: docsLink.Billing,
      docKey: "BILLING_DESC"
    },
    "Auth Configuration": {
      docLink: docsLink["Auth Configuration"],
      docKey: "AUTHENTICATION_CONFIGURATION_DESC"
    },
    "Team SSO": {
      docLink: docsLink["Team SSO"],
      docKey: "TEAM_SSO_DESC"
    },
    APIs: {
      docLink: docsLink.APIs,
      docKey: "API_DESC"
    }
  },
  card: {
    "Account API Keys": {
      docKey: "ACCOUNT_API_KEY_CARD_DESCRIPTION"
    },
    "Additional API Secret(s)": {
      docKey: "ADDITIONAL_API_SECRETS_CARD_DESCRIPTION"
    },

    "Privacy Versioning": {
      docKey: "PRIVACY_VERSIONING_CARD_HEADER"
    },
    "Age Verification": {
      docKey: "AGE_VERIFICATION_CARD_HEADER"
    },
    "Inbound SSO": {
      docKey: "INBOUND_SSO_CARD_HEADER"
    },
    "Outbound SSO": {
      docKey: "OUTBOUND_SSO_CARD_HEADER"
    },
    "SSO Connectors": {
      docKey: "SSO_CONNECTORS_CARD_DESC"
    },
    "Consent Management": {
      docKey: "CONSENT_MANAGEMENT_CARD_DESC"
    },
    "Brute Force Protection": {
      docKey: "BRUTE_FORCE_PROTECTION_CARD_DESC"
    },
    "Bot Protection": {
      docKey: "BOT_PROTECTIONS_HEADER"
    },
    "API Security": {
      docKey: "BOT_PROTECTION_CARD_DESC"
    },
    "Domain Access Management": {
      docKey: "ACCESS_RESTRICTION_CARD_DESC"
    },
    "IP Access Management": {
      docKey: "IP_DOMAIN_ACCESS_MANAGEMENT_CARD_DESC"
    },
    "Password Expiration": {
      docKey: "PASSWORD_EXPIRATION_HEADER"
    },
    "Password History": {
      docKey: "PASSWORD_HISTORY_HEADER"
    },
    "Password Complexity": {
      docKey: "PASSWORD_COMPLEXITY_HEADER"
    },
    "Breached Password Protection": {
      docKey: "BREACHED_PASSWORD_DESCRIPTION"
    },
    "Consumer Audit Logs": {
      docKey: "CONSUMER_AUDIT_LOGS_RECENT_ACCOUNT_ACTIVITIES"
    },
    Apps: {
      docLink: docsLink.Apps,
      docKey: "APPS_DESCRIPTION"
    },
    Organization: {
      docLink: docsLink.Organizations,
      docKey: "ORGANIZATIONS_DESCRIPTION"
    }
  }
};

export const captchaLink = [
  {
    value: "GoogleRecaptchaV2",
    text: "reCAPTCHA V2",
    link: docsLink["GoogleRecaptchaV2"]
  },

  {
    value: "GoogleRecaptchaV3",
    text: "reCAPTCHA V3",
    link: docsLink["GoogleRecaptchaV3"]
  },

  {
    value: "HCaptcha",
    text: "hCaptcha",
    link: docsLink["HCaptcha"]
  },

  {
    value: "QQTencentCaptcha",
    text: "QQ Tencent CAPTCHA",
    link: docsLink["QQTencentCaptcha"]
  }
];

type FeatureRestrictContent = {
  icon: string;
  title: string;
  description: string;
};

type FeatureRestrictContainer = {
  title: string;
  description: string;
  image: string;
  content: FeatureRestrictContent[];
  imageAlign: "right" | "center";
  contentType: "horizontal" | "vertical";
};

export const FeatureRestrictContainerMap: Record<string, FeatureRestrictContainer> = {
  passwordless: {
    title: "Passwords Cause 80% of Breaches",
    description: "Passwordless authentication stops phishing and credential theft at the root. Give customers frictionless logins that build trust—and keep revenue safe.",
    image: "/assets/images/FeatureRestrictContainer/passwordless.svg",
    imageAlign: "center",
    contentType: "horizontal",
    content: [
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Hassle-free Access.svg",
        title: "Hassle-free Access",
        description: "Let users log in quickly without passwords"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Enhanced Security.svg",
        title: "Enhanced Security",
        description: "Device-bound, phishing-resistant credentials protect accounts"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Future-Ready.svg",
        title: "Future-Ready",
        description: "Built on FIDO2 and WebAuthn for long-term standards"
      }
    ]
  },
  SSO: {
    title: "48% of Consumers Prefer Apps with SSO",
    description: "Enable SSO so users can access multiple apps without repeated credentials. Boost sign-ups and reduce churn.",
    image: "/assets/images/FeatureRestrictContainer/ssoIntegration.svg",
    imageAlign: "right",
    contentType: "vertical",
    content: [
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Seamless Access.svg",
        title: "Seamless Access",
        description: "Frictionless access across apps, sites, and stores"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Central Control.svg",
        title: "Central Control",
        description: "Manage identities consistently across your ecosystem"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Enhanced Security.svg",
        title: "Boost Security",
        description: "Reduce password fatigue and phishing risks with unified login"
      }
    ]
  },
  "Custom IDPs": {
    title: "Integrate Your Custom IdP in Minutes",
    description: "Upgrade to Custom Identity Providers and connect SAML or OIDC-based IdPs like Azure AD, Okta, or Ping—secure, compliant, and ready for your organization.",
    image: "/assets/images/FeatureRestrictContainer/customIdps.svg",
    imageAlign: "center",
    contentType: "horizontal",
    content: [
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Faster Setup.svg",
        title: "Faster Setup",
        description: "Add Okta, Azure AD, or any IdP with just a few lines of config code"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Standards-Ready.svg",
        title: "Standards-Ready",
        description: "Works out-of-the-box with SAML and OIDC protocols"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Built for Scale.svg",
        title: "Built for Scale",
        description: "Support multiple IdPs across apps, regions, and tenants"
      }
    ]
  },
  Passkeys: {
    title: "53% of Users Feel Passkeys Are More Secure Than Passwords",
    description:
      "Upgrade to Passkeys for phishing-proof logins across devices. Cut the risks tied to stolen or weak credentials and reduce support overhead, while delivering superior customer experience",
    image: "/assets/images/FeatureRestrictContainer/passkeys.svg",
    imageAlign: "center",
    contentType: "horizontal",
    content: [
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Proactive Defense.svg",
        title: "Phishing Proof",
        description: "Stop account takeover with un-guessable, device-bound credentials"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Cross-Device.svg",
        title: "Cross-Device",
        description: "Log in seamlessly across desktop, mobile, and browsers"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Future-Ready.svg",
        title: "Future Ready",
        description: "Built on FIDO2 for lasting security standards"
      }
    ]
  },
  "Bot Protection": {
    title: "Stop Bots Before They Attack Your Customers",
    description:
      "LoginRadius Bot Protection utilizes CAPTCHA challenges to effectively detect and block automated bots, safeguarding your applications from malicious activities such as credential stuffing, fake registrations, and data scraping.",
    image: "/assets/images/FeatureRestrictContainer/botProtection.svg",
    imageAlign: "center",
    contentType: "horizontal",
    content: [
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/captcha_6437002 1.svg",
        title: "Smart CAPTCHA",
        description: "Integrate reCAPTCHA, hCaptcha, or QQ Tencent CAPTCHA"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Custom Triggers.svg",
        title: "Custom Triggers",
        description: "Show challenges at login, registration, or reset"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/warning_8297690 1.svg",
        title: "Fraud Prevention",
        description: "Stop account takeover and fake sign-ups"
      }
    ]
  },
  "Breached Password Protection": {
    title: "24B+ Breached Passwords Are Still in Use Today!",
    description:
      "Compromised passwords put your brand and customers at risk. Our Breached Password Protection feature prevents customers from creating or resetting accounts with known compromised passwords, cutting risks before they start!.",
    image: "/assets/images/FeatureRestrictContainer/passwordless.svg",
    imageAlign: "center",
    contentType: "horizontal",
    content: [
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Proactive Defense.svg",
        title: "Proactive Defense",
        description: "Block known-compromised passwords before they spread risk"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Win User Trust.svg",
        title: "Win Customer Trust",
        description: "Manage identities consistently across your ecosystem"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Reduce ATO.svg",
        title: "Reduce ATO",
        description: "Limit credential stuffing and account takeovers"
      }
    ]
  },
  "Brute Force Protection": {
    title: "Turn 20% Brute Force Success Into 0%",
    description:
      "Brute force attacks succeed 1 in 5 times if left unchecked. Loginradius Brute Force Protection locks down accounts after a pre-decided number of failed login or reset attempts, defending customers before attackers get in.",
    image: "/assets/images/FeatureRestrictContainer/bruteForce.svg",
    imageAlign: "center",
    contentType: "horizontal",
    content: [
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Attack Prevention.svg",
        title: "Attack Prevention",
        description: "Automatically stop repeated login attempts and bots"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Win User Trust.svg",
        title: "Win User Trust",
        description: "Protect customers from unauthorized access and fraud"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Visible Monitoring.svg",
        title: "Visible Monitoring",
        description: "Track lockout events and detect targeted attack patterns"
      }
    ]
  },
  "Domain Access Management": {
    title: "Allow Only the Right Users, From the Right Domains",
    description: "Decide exactly who can register or log in by allowing or blocking domains. Keep out disposable emails, restrict unwanted signups, and align access with business rules.",
    image: "/assets/images/FeatureRestrictContainer/domainAccessManagement.svg",
    imageAlign: "right",
    contentType: "vertical",
    content: [
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/allowed_4196748 1.svg",
        title: "Blocklist Risk",
        description: "Block disposable or malicious email domains"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/allowed_4196748 2.svg",
        title: "Allowlist Domains",
        description: "Allow trusted domains for smooth onboarding"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Prevent Spam.svg",
        title: "Prevent Spam",
        description: "Prevent fake or bot-driven signups instantly"
      }
    ]
  },
  "Multi Factor Authentication": {
    title: "MFA Blocks 99.9% of Automated Attacks",
    description:
      "Give your customers the confidence that their accounts are safe. MFA adds an extra layer of security, helping customers protect accounts from phishing, credential theft, and fraud, without disrupting their login experience.",
    image: "/assets/images/FeatureRestrictContainer/MFA.svg",
    imageAlign: "center",
    contentType: "horizontal",
    content: [
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Enhanced Security.svg",
        title: "Stronger Security",
        description: "Combine password with OTP, push, or biometrics"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Fraud Protection.svg",
        title: "Fraud Protection",
        description: "Block phishing and account takeover attempts"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Custom Triggers.svg",
        title: "Flexible Options",
        description: "Offer multiple options including  SMS, email, push, TOTP, or passkeys"
      }
    ]
  },
  "Risk-Based Authentication": {
    title: "Smarter Security - Only When Needed!",
    description:
      "Risk-Based Authentication adapts security checks in real time. Legitimate customers enjoy seamless access, while suspicious logins trigger additional verification to stop fraud before it happens.",
    image: "/assets/images/FeatureRestrictContainer/RBA.svg",
    imageAlign: "center",
    contentType: "horizontal",
    content: [
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Audit Ready.svg",
        title: "Smart Checks",
        description: "Trigger extra verification automatically for unknown login locations"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Seamless UX.svg",
        title: "Seamless Access",
        description: "Legitimate users log in with zero friction"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Audit Ready.svg",
        title: "Audit Ready",
        description: "Track suspicious logins for security and compliance reporting"
      }
    ]
  },
  "PIN Authentication": {
    title: "Frictionless Login With Stronger Security",
    description:
      "LoginRadius PIN Authentication lets customers log in quickly with a personal PIN, reducing password fatigue and support requests while keeping accounts protected from unauthorized access.",
    image: "/assets/images/FeatureRestrictContainer/PinAuth.svg",
    imageAlign: "right",
    contentType: "vertical",
    content: [
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Faster Access.svg",
        title: "Faster Access",
        description: "Let your users login in seconds with a simple PIN"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Stronger Account Protection.svg",
        title: "Stronger Protection",
        description: "Reduce credential theft and misuse"
      }
    ]
  },
  "Consent Management": {
    title: "71% of Your Users Expect Data Transparency – We Deliver It",
    description: "Give customers control over their data choices with just a few clicks and ensure your business stays compliant with global privacy regulations.",
    image: "/assets/images/FeatureRestrictContainer/consentManagement.svg",
    imageAlign: "right",
    contentType: "vertical",
    content: [
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Regulation Ready.svg",
        title: "Regulation Ready",
        description: "Meet GDPR, CCPA, and other compliance standards"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Seamless UX.svg",
        title: "Seamless UX",
        description: "Let users manage permissions easily"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Centralized Management.svg",
        title: "Centralized Management",
        description: "Track, update, and honor preferences from one place"
      }
    ]
  },
  APIs: {
    title: "APIs That Power Seamless Logins",
    description: "LoginRadius APIs give you full control over authentication and user management, so you can deliver secure, seamless experiences across all apps and devices.",
    image: "/assets/images/FeatureRestrictContainer/API.svg",
    imageAlign: "right",
    contentType: "vertical",
    content: [
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Developer Friendly.svg",
        title: "Developer Friendly",
        description: "REST, GraphQL, and detailed docs"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Extensive.svg",
        title: "Extensive APIs",
        description: "Covers identity, security, user insights, and more!"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Built for Scale.svg",
        title: "Built for Scale",
        description: "Handle millions of API calls reliably"
      }
    ]
  },
  Orchestration: {
    title: "Orchestrate Identity Your Way",
    description:
      "Visually design and deploy workflows for registration, login, MFA, and more. Use them across all your brands to ensure speed, consistency, and strong security — without writing code.",
    image: "/assets/images/FeatureRestrictContainer/workflows.svg",
    imageAlign: "center",
    contentType: "horizontal",
    content: [
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Faster Time to Market.svg",
        title: "Faster Time-to-Market",
        description: "Roll out new user journeys in minutes, not weeks."
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Low-Code Control.svg",
        title: "Low-Code Control",
        description: "Design workflows visually, skip dev delays"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/recycling_8981143 1.svg",
        title: "Reusable at Scale",
        description: "Build once, apply across apps, brands, and regions"
      }
    ]
  },
  Scripts: {
    title: "Customize Auth Without Limits",
    description: "Scripts let you extend LoginRadius flows with custom logic—build unique experiences, enforce rules, or connect external services.",
    image: "/assets/images/FeatureRestrictContainer/scripts.svg",
    imageAlign: "right",
    contentType: "vertical",
    content: [
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/api_18474924 1.svg",
        title: "Easy Integrations",
        description: "Connect analytics, fraud detection tools, or CRMs"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/control_5919055 1.svg",
        title: "Full Control",
        description: "Add validation, branding, or UI tweaks"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/certificate_10439518 1.svg",
        title: "Policy Enforcement",
        description: "Run custom checks during authentication"
      }
    ]
  },
  ProgressiveProfiling: {
    title: "60% of Your Users may Abandon Long Registration Forms",
    description: "Progressive Profiling reduces friction by asking only what’s needed upfront, and keep gathering the rest of the data over time.",
    image: "/assets/images/FeatureRestrictContainer/progressiveProfiling.svg",
    imageAlign: "center",
    contentType: "horizontal",
    content: [
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Boost Sign Ups.svg",
        title: "Boost Sign-Ups",
        description: "Reduce drop-offs with leaner forms"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Customer Friendly.svg",
        title: "Customer Friendly",
        description: "Collect data gradually, without frustration"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Richer Data.svg",
        title: "Richer Data",
        description: "Build complete customer profiles over time"
      }
    ]
  },
  "User Segmentations": {
    title: "Target the Right Customers, Every Time",
    description: "Identify and group the right users for marketing, product rollouts, or A/B testing, making every interaction more relevant.",
    image: "/assets/images/FeatureRestrictContainer/segmentation.svg",
    imageAlign: "right",
    contentType: "vertical",
    content: [
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Filter Users.svg",
        title: "Filter Users",
        description: "Group users based on inactivity, login providers, or key attributes"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Segment and Analyze.svg",
        title: "Segment & Analyze",
        description: "Create segments based on geography, demographics, and custom behaviors"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Act and Engage.svg",
        title: "Act & Engage",
        description: "Export segmented list for campaigns, promotions, or product experiments"
      }
    ]
  },
  "Data Export": {
    title: "Seamless Customer Data Exports",
    description: "Export customer records in bulk to stay compliant, run deep analytics, or fuel marketing and product campaigns.",
    image: "/assets/images/FeatureRestrictContainer/dataExports.svg",
    imageAlign: "right",
    contentType: "vertical",
    content: [
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Flexible Formats.svg",
        title: "Flexible Formats",
        description: "Export as CSV or JSON anytime"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/BI Friendly.svg",
        title: "BI Friendly",
        description: "Plug into analytics, CDP, or CRM tools"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Compliance Ready.svg",
        title: "Compliance Ready",
        description: "Simplify GDPR, CCPA, and audit requests"
      }
    ]
  },
  "User Audit Logs": {
    title: "Stay Ahead With Transparent Logs",
    description: "Never lose track of who did what, when, and from where. Audit Logs make system monitoring and compliance effortless.",
    image: "/assets/images/FeatureRestrictContainer/auditLogs.svg",
    imageAlign: "center",
    contentType: "horizontal",
    content: [
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Detailed Records.svg",
        title: "Detailed Records",
        description: "Timestamps, IPs, and user activity logs"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/insurance_9436979 1.svg",
        title: "Security Focused",
        description: "Spot anomalies and malicious activity early"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/upload_11342398 1.svg",
        title: "Easy Export",
        description: "Export logs for audits or SIEM tools"
      }
    ]
  },
  "User Analytics": {
    title: "Turn Identity Data Into Business Growth",
    description: "Go beyond tracking just sign-ups - track how customers log in, which devices they use, and how often they return. Turn raw authentication data into clear customer insights.",
    image: "/assets/images/FeatureRestrictContainer/analytics.svg",
    imageAlign: "center",
    contentType: "horizontal",
    content: [
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Engagement Trends.svg",
        title: "Engagement Trends",
        description: "Daily active users, returning logins, inactivity"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Login Behavior.svg",
        title: "Login Behavior",
        description: "Frequency, device/browser types, geo distribution"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/Acquisition Insights.svg",
        title: "Acquisition Insights",
        description: "User growth, login preferences and demographics"
      }
    ]
  },
  "Platform Analytics": {
    title: "Teams Catch API Issues 3x Faster With Real-Time Analytics",
    description: "Platform Analytics tracks traffic trends, threat sources, slow endpoints, and response times, helping you secure your APIs and resolve issues before they affect users.",
    image: "/assets/images/FeatureRestrictContainer/platform_analytics.svg",
    imageAlign: "center",
    contentType: "horizontal",
    content: [
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/graph.svg",
        title: "Full Traffic Visibility",
        description: "Real-time trends across every endpoint"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/threat.svg",
        title: "Early Threat Detection",
        description: "Flag suspicious IPs and user agents fast"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/instant.svg",
        title: "Faster Resolution",
        description: "Catch slow endpoints before users do"
      }
    ]
  },
  "Custom Domain": {
    title: "Manage Multiple Custom Domains, Effortlessly",
    description: "Add and manage multiple domains from a single place. Style domain-specific authentication experiences along with Custom Domains for improved trust.",
    image: "/assets/images/FeatureRestrictContainer/multipleCustomDomain.svg",
    imageAlign: "right",
    contentType: "vertical",
    content: [
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/carbon_connect.svg",
        title: "Map Templates to Domains",
        description: "Choose which authentication template applies to each domain for consistent, branded experiences"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/configuration-file.svg",
        title: "Centralized Configuration",
        description: "Maintain control and visibility across all domains while simplifying ongoing management"
      },
      {
        icon: "/assets/images/FeatureRestrictContainer/icons/paint-palette-solid.svg",
        title: "Consistent Branding Across Domains",
        description: "Ensure every domain follows your brand guidelines while allowing controlled variations"
      }
    ]
  }
};
